import { createRouter, createWebHistory } from "vue-router";
// import HomeView from '../views/HomeView'

const routes = [
  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layouts/AuthLayout"),
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/auth/Login"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Login",
        },
      },
      {
        path: "/forgot-password",
        name: "forgot-password",
        component: () => import("../views/auth/ForgotPassword"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Forgot Password",
        },
      },
      {
        path: "/account-confirm/:token",
        name: "Account Confirmation",
        component: () => import("../views/auth/AccountConfirmation"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Account Confirmation",
        },
      },
      {
        path: "/reset-password/:token",
        name: "Reset Password",
        component: () => import("../views/auth/ResetPassword"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Reset Password",
        },
      },
      {
        path: "/otp",
        name: "OTP",
        component: () => import("../views/auth/Otp"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | OTP",
        },
      },
      {
        path: "/email-notification",
        name: "Email Notification",
        component: () => import("../views/auth/EmailNotification"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Email Notification",
        },
      },
    ],
  },
  {
    path: "/dashboard",
    component: () => import("@/layouts/DashboardLayout"),
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("../views/Dashboard"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Dashboard",
        },
      },
      {
        path: "/notifications",
        name: "Notifications",
        component: () => import("../views/Notifications"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Notification",
        },
      },
      {
        path: "/ticket-notification",
        name: "NCC Notifications",
        component: () => import("../views/NCCNotification"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Notification",
        },
      },
      {
        path: "/ticket-notifications",
        name: "OCCSP Notifications",
        component: () => import("../views/OCCSPNotification"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Notification",
        },
      },
      {
        path: "/dashboard/change-password",
        name: "Change Password",
        component: () => import("../views/ChangePassword"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | User Profile",
        },
      },
      {
        path: "/dashboard/profile",
        name: "Profile",
        component: () => import("../views/Profile"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Profile",
        },
      },
      {
        path: "/dashboard/user/:id",
        name: "UserProfile",
        component: () => import("../views/user_management/UserProfile"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | User Profile",
        },
      },
      {
        path: "/dashboard/user/create",
        name: "Create User",
        component: () => import("../views/user_management/CreateUser"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | User Profile",
        },
      },
      {
        path: "/dashboard/user/edit/:id",
        name: "Update User",
        component: () => import("../views/user_management/EditUser"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | User Profile",
        },
      },
      {
        path: "/dashboard/user",
        name: "User List",
        component: () => import("../views/user_management/ListUser"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | User List",
        },
      },
      {
        path: "/dashboard/complaint/create",
        name: "CreateComplaint ",
        component: () => import("../views/complaint/CreateComplaint"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | User List",
        },
      },
      {
        path: "/dashboard/complaint",
        name: "Report List",
        component: () => import("../views/complaint/ComplaintList"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Report List",
        },
      },
      {
        path: "/dashboard/complaint/:id",
        name: "ViewReport",
        component: () => import("../views/complaint/ViewComplaint"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | User List",
        },
      },
      {
        path: "/dashboard/data-upload",
        name: "Upload Complaint",
        component: () => import("../views/complaint/BulkUpload"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Bulk Upload",
        },
      },
      {
        path: "/dashboard/contact",
        name: "Contact List",
        component: () => import("../views/contact-management/ContactList"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Contact List",
        },
      },
      {
        path: "/dashboard/contact/create",
        name: "Create Contact ",
        component: () => import("../views/contact-management/CreateContact"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Create Contact",
        },
      },
      {
        path: "/dashboard/contact/:id",
        name: "ViewContact",
        component: () => import("../views/contact-management/ViewContact"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | View Contact",
        },
      },
      {
        path: "/dashboard/contact/edit/:id",
        name: "EditContact ",
        component: () => import("../views/contact-management/CreateContact"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Edit Contact",
        },
      },
      {
        path: "/settings",
        name: "Settings",
        component: () => import("../views/settings/Settings"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Settings",
        },
      },
      {
        path: "/settings/view-sp",
        name: "Create Service Provider",
        component: () => import("../views/settings/ViewSP"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Create Service Provider",
        },
      },
      {
        path: "/reports",
        name: "Reports",
        component: () => import("@/views/reports/Reports"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Reports",
        },
      },
      {
        path: "/reports/complaint-by-state",
        name: "Complaints By State",
        component: () => import("../views/reports/ComplaintsByStates"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints",
        },
      },
      {
        path: "/reports/complaint-by-category",
        name: "Complaints By Category",
        component: () => import("../views/reports/ComplaintsByCategory"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints By Category",
        },
      },
      {
        path: "/reports/complaint-by-geozone",
        name: "Complaints By GeoPolitical Zone",
        component: () => import("../views/reports/ComplaintsByGeoZone"),
        meta: {
          disableIfLoggedIn: true,
          title:
            "NCAA | Complaints By GeoPolitical Zone",
        },
      },
      {
        path: "/reports/complaint-by-source",
        name: "Complaints By Source",
        component: () => import("../views/reports/ComplaintsBySource"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints By Source",
        },
      },
      {
        path: "/reports/complaint-by-sp",
        name: "Complaints By Service Provider",
        component: () => import("../views/reports/ComplaintsBySP"),
        meta: {
          disableIfLoggedIn: true,
          title:
            "NCAA | Complaints By Service Provider",
        },
      },
      {
        path: "/reports/complaint-by-status",
        name: "Complaints By Status",
        component: () => import("../views/reports/ComplaintsByStatus"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints By Status",
        },
      },{
        path: "/reports/complaint-by-sla-breach",
        name: "Complaints By SLA Breach",
        component: () => import("../views/reports/ComplaintsByBreachedStatus"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints By SLA Breach",
        },
      },
      {
        path: "/reports/complaint-by-language",
        name: "Complaints By Language",
        component: () => import("../views/reports/ComplaintsByLanguage"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints By Language",
        },
      },
      {
        path: "/reports/case-type",
        name: "Complaints By Language",
        component: () => import("../views/reports/CaseType"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Case Type",
        },
      },
      {
        path: "/sla",
        name: "Service Level Agreements",
        component: () => import("../views/SLA"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Service Level Agreements",
        },
      },
      {
        path: "/reports/complaint-by-state-sp",
        name: "Complaints By State SP",
        component: () => import("../views/reports/ComplaintsByStatesSPs"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints",
        },
      },
      {
        path: "/reports/complaint-by-geozone-sp",
        name: "Complaints By GeoPolitical Zone SP",
        component: () => import("../views/reports/ComplaintsByGeoZoneSPs"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints",
        },
      },
      {
        path: "/reports/complaint-by-status-sp",
        name: "Complaints By Status SP",
        component: () => import("../views/reports/ComplaintsByStatusSPs"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints",
        },
      },
      {
        path: "/reports/complaint-by-category-sp",
        name: "Complaints By Category SP",
        component: () => import("../views/reports/ComplaintsByCategorySPs"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Complaints",
        },
      },
      {
        path: "/reports/complaint-by-state-occsp",
        name: "Complaints By State OCCSP",
        component: () => import("../views/reports/ComplaintsByStatesOCCSP"),
        meta: {
          disableIfLoggedIn: true,
          title:
            "NCAA | Complaints by State OCCSP",
        },
      },
      {
        path: "/reports/complaint-by-category-occsp",
        name: "Complaints By Category OCCSP",
        component: () => import("../views/reports/ComplaintsByCategoryOCCSP"),
        meta: {
          disableIfLoggedIn: true,
          title:
            "NCAA | Complaints By Category OCCSP",
        },
      },
      {
        path: "/reports/complaint-by-geozone-occsp",
        name: "Complaints By GeoPolitical Zone OCCSP",
        component: () => import("../views/reports/ComplaintsByGeoZoneOCCSP"),
        meta: {
          disableIfLoggedIn: true,
          title:
            "NCAA | Complaints By GeoPolitical Zone OCCSP",
        },
      },
      {
        path: "/reports/complaint-by-sp-occsp",
        name: "Complaints By Service Provider OCCSP",
        component: () => import("../views/reports/ComplaintsBySPOCCSP"),
        meta: {
          disableIfLoggedIn: true,
          title:
            "NCAA | Complaints By Service Provider OCCSP",
        },
      },
      {
        path: "/reports/complaint-by-status-occsp",
        name: "Complaints By Status OCCSP",
        component: () => import("../views/reports/ComplaintsByStatusOCCSP"),
        meta: {
          disableIfLoggedIn: true,
          title:
            "NCAA | Complaints By Status OCCSP",
        },
      },
      {
        path: "/reports/complaint-by-language-occsp",
        name: "Complaints By Language OCCSP",
        component: () => import("../views/reports/ComplaintsByLanguageOCCSP"),
        meta: {
          disableIfLoggedIn: true,
          title:
            "NCAA | Complaints By Language OCCSP",
        },
      },
      {
        path: "/directorate",
        name: "Directorate",
        component: () => import("@/views/directorate/Directorate"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Directorate",
        },
      },
      {
        path: "/directorate/air-worthiness",
        name: "AirWorthiness",
        component: () => import("@/views/directorate/air-worthiness"),
        meta: { disableIfLoggedIn: true, title: "NCAA | Air Worthiness" },
      },
      {
        path: "/directorate/aircraft-registry",
        name: "AircraftRegistry",
        component: () => import("@/views/directorate/aircraft-registry"),
        meta: { disableIfLoggedIn: true, title: "NCAA | Aircraft Registry" },
      },
      {
        path: "/directorate/anc-incidents",
        name: "ANCIncidents",
        component: () => import("@/views/directorate/anc-incidents"),
        meta: { disableIfLoggedIn: true, title: "NCAA | ANC Incidents" },
      },
      {
        path: "/directorate/consumer-complaints",
        name: "ConsumerComplaints",
        component: () => import("@/views/directorate/consumer-complaints"),
        meta: { disableIfLoggedIn: true, title: "NCAA | Consumer Complaints" },
      },
      {
        path: "/directorate/cs-ict",
        name: "CSICT",
        component: () => import("@/views/directorate/cs-ict"),
        meta: { disableIfLoggedIn: true, title: "NCAA | CS ICT" },
      },
      {
        path: "/directorate/cs-procurement",
        name: "CSProcurement",
        component: () => import("@/views/directorate/cs-procurement"),
        meta: { disableIfLoggedIn: true, title: "NCAA | CS Procurement" },
      },
      {
        path: "/directorate/inspection",
        name: "Inspection",
        component: () => import("@/views/directorate/inspection"),
        meta: { disableIfLoggedIn: true, title: "NCAA | Inspection" },
      },
      {
        path: "/directorate/flight-ops",
        name: "FlightOps",
        component: () => import("@/views/directorate/flight-ops"),
        meta: { disableIfLoggedIn: true, title: "NCAA | Flight Ops" },
      },
      {
        path: "/directorate/hr",
        name: "HR",
        component: () => import("@/views/directorate/hr"),
        meta: { disableIfLoggedIn: true, title: "NCAA | Human Resources" },
      },
      {
        path: "/directorate/lkp-airlines",
        name: "LKPAirlines",
        component: () => import("@/views/directorate/lkp-airlines"),
        meta: { disableIfLoggedIn: true, title: "NCAA | LKP Airlines" },
      },
      {
        path: "/directorate/lkp-by-operators",
        name: "LKPByOperators",
        component: () => import("@/views/directorate/lkp-by-operators"),
        meta: { disableIfLoggedIn: true, title: "NCAA | LKP By Operators" },
      },
      {
        path: "/directorate/iata",
        name: "IATA",
        component: () => import("@/views/directorate/iata"),
        meta: { disableIfLoggedIn: true, title: "NCAA | IATA" },
      },
      {
        path: "/directorate/icao",
        name: "ICAO",
        component: () => import("@/views/directorate/icao"),
        meta: { disableIfLoggedIn: true, title: "NCAA | ICAO" },
      },
      {
        path: "/directorate/fir",
        name: "FIR",
        component: () => import("@/views/directorate/fir"),
        meta: { disableIfLoggedIn: true, title: "NCAA | FIR" },
      },
      {
        path: "/directorate/wild-life",
        name: "WildLife",
        component: () => import("@/views/directorate/wild-life"),
        meta: { disableIfLoggedIn: true, title: "NCAA | Wild Life" },
      },
      {
        path: "/directorate/safety-occurrences",
        name: "SafetyOccurrences",
        component: () => import("@/views/directorate/safety-occurrences"),
        meta: { disableIfLoggedIn: true, title: "NCAA | Safety Occurrences" },
      },

      {
        path: "/audit",
        name: "Audit-Trail",
        component: () => import("@/views/audit-trail/AuditTrail"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | Audit Trail",
        },
      },
      {
        path: "/404",
        name: "404",
        component: () => import("@/views/404"),
        meta: {
          disableIfLoggedIn: true,
          title: "NCAA | 404",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)",
    name: "not-found",
    component: () => import("@/views/404"),
    meta: {
      disableIfLoggedIn: true,
      title: "NCAA | 404",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to);
  document.title = to.meta.title;
  next();
});

export default router;
